// extracted by mini-css-extract-plugin
export default {"input":"PhoneInput_input__F+2aJ","small":"PhoneInput_small__wwzMw","middle":"PhoneInput_middle__wJ1ab","large":"PhoneInput_large__s6OuN"};